<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";


//import { ApiAuth } from '@/router/views/login/ApiAuth'
import { ApiAuth } from '../login/ApiAuth'
import { ApiFac } from '../siscmpfc/fac/ApiFac'
import { ApiInv } from '../siscmpfc/inv/ApiInv'

//const apiAuth = new ApiAuth()

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      apiAuth: new ApiAuth(),
      apiFac: new ApiFac(),
      apiInv: new ApiInv(),
      totalClientes:0,
      totalProdutos:0,
      title: "Dashboard",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      statData: [
        {
          icon: "bx bx-copy-alt",
          title: "Orders",
          value: "1,235",
        },
        {
          icon: "bx bx-archive-in",
          title: "Revenue",
          value: "$35, 723",
        },
        {
          icon: "bx bx-purchase-tag-alt",
          title: "Average Price",
          value: "$16.2",
        },
      ],
      transactions: [
        {
          id: "#SK2540",
          name: "Neal Matthews",
          date: "07 Oct, 2019",
          total: "$400",
          status: "Paid",
          payment: ["fa-cc-mastercard", "Mastercard"],
          index: 1,
        },
        {
          id: "#SK2541",
          name: "Jamal Burnett",
          date: "07 Oct, 2019",
          total: "$380",
          status: "Chargeback",
          payment: ["fa-cc-visa", "Visa"],
          index: 2,
        },
        {
          id: "#SK2542",
          name: "Juan Mitchell",
          date: "06 Oct, 2019",
          total: "$384",
          status: "Paid",
          payment: ["fab fa-cc-paypal", "Paypal"],
          index: 3,
        },
        {
          id: "#SK2543",
          name: "Barry Dick",
          date: "05 Oct, 2019",
          total: "$412",
          status: "Paid",
          payment: ["fa-cc-mastercard", "Mastercard"],
          index: 4,
        },
        {
          id: "#SK2544",
          name: "Ronald Taylor",
          date: "04 Oct, 2019",
          total: "$404",
          status: "Refund",
          payment: ["fa-cc-visa", "Visa"],
          index: 5,
        },
        {
          id: "#SK2545",
          name: "Jacob Hunter",
          date: "04 Oct, 2019",
          total: "$392",
          status: "Paid",
          payment: ["fab fa-cc-paypal", "Paypal"],
          index: 6,
        },
      ],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#ffffff",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
    };
  },
  created(){
      this.verificaAcesso()
  },
  mounted() {
    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },
  methods:{
      async verificaAcesso(){
        console.log('entrou no verifica acesso')
        try {
          /* let token = await this.apiAuth.getToken()
          if(token.access == null || token.access == undefined){
            alert('1')
            this.$router.push('/login')
          }
          if(token.detail){
            alert('2')
            return token.detail
          }
          console.log(token) */
          let clientes = await this.apiFac.getCliente(-1)
          console.log('clientes: ', clientes)
          if(clientes.detail){
            console.log('foi pro login')
            this.$router.push('/login')
          }
          console.log(clientes)
          this.totalClientes = clientes.length

          //let produtos = await this.apiInv.getProdutos(-1)
          //this.totalProdutos = produtos.length
        } catch (error) {
          //alert(error.toString())
          this.mensagemErro(error);
        }
      },
      irSite(){
       // this.$router.push('/')
      }
    }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <v-col>
        <v-row>
          <v-col cols="12" md="3">
            <v-card @click="irSite">
              <v-card-title>Clientes</v-card-title>
              <v-card-text><h1>{{totalClientes}}</h1></v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card>
              <v-card-title>Produtos</v-card-title>
              <v-card-text><h1>{{totalProdutos}}</h1></v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

  </Layout>
</template>
